import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiUrl } from "../../../constants";
import FormSettingsItem from "../formSettingsItem/FormSettingsItem";
import styles from "./Overview.module.css";
import FunctionalButton from "../../button/FunctionalButton";
import AddForm from "../addForm/AddForm";
import sortListSubheadingsAlphabetical from "../../../helpers/sortListSubheadingsAlphabetical";
import UpdateForm from "../updateForm/UpdateForm";
import sortCountriesAlphabetical from "../../../helpers/sortCountriesAlphabetical";
import sortPublishersAlphabetical from "../../../helpers/sortPublishersAlphabetical";

const Overview = ({
  showFullList,
  toggleShowFullList,
  insertForm,
  toggleInsertForm,
  toggleDeleteForm,
  reloadAll,
  toggleReloadAll,
  displayContainer,
  toggleDisplayContainer,
  route,
}) => {
  const [listOptions, setListOptions] = useState([]);
  const [filterResult, setFilterResult] = useState([]);
  const [sortedCompleteList, setSortedCompleteList] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [noResultError, toggleNoResultError] = useState(false);
  const [errorMessage, toggleErrorMessage] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [showUpdateForm, toggleShowUpdateForm] = useState(false);
  const [itemToBeUpdated, setItemToBeUpdated] = useState("");
  const [idItemToBeUpdated, setIdItemToBeUpdated] = useState("");
  const [title, setTitle] = useState("");
  const [databaseMessage, setDatabaseMessage] = useState("");

  useEffect(() => {
    getAll();
  }, []);

  useEffect(() => {
    if (route === "subheadings") {
      setTitle("subheading");
    }

    if (route === "countries") {
      setTitle("country");
    }
    if (route === "publishers") {
      setTitle("publisher");
    }
  }, [route]);

  useEffect(() => {
    if (reloadAll) {
      getAll();
    }
  }, [reloadAll]);

  async function getAll() {
    toggleErrorMessage(false);
    toggleReloadAll(false);
    setListOptions([]);
    setFilterResult([]);
    const jwtToken = localStorage.getItem("token");
    toggleLoading(true);
    try {
      const { data } = await axios.get(`${apiUrl}/formsettings/${route}`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      setListOptions(data);
      setFilterResult(data);
    } catch (e) {
      console.error(e);
      toggleErrorMessage(true);
      if (e.response !== undefined) {
        setDatabaseMessage(e.response.data.message);
      } else {
        setDatabaseMessage("Something went wrong. Please try again later.");
      }
    }
    toggleLoading(false);
  }

  useEffect(() => {
    function sortListItems() {
      if (route === "subheadings") {
        setSortedCompleteList(sortListSubheadingsAlphabetical(listOptions));
        setFilterResult(sortListSubheadingsAlphabetical(listOptions));
      } else if (route === "countries") {
        setSortedCompleteList(sortCountriesAlphabetical(listOptions));
        setFilterResult(sortCountriesAlphabetical(listOptions));
      } else if (route === "publishers") {
        setSortedCompleteList(sortPublishersAlphabetical(listOptions));
        setFilterResult(sortPublishersAlphabetical(listOptions));
      }
    }

    if (listOptions) {
      sortListItems();
    }
  }, [listOptions]);

  // Here we filter the list with results on every keypress
  function filterResultsList(value) {
    toggleNoResultError(false);
    const newResult = [];
    sortedCompleteList?.map((item) => {
      if (item[title].toLowerCase().includes(value)) {
        newResult.push(item);
      }
    });

    if (newResult.length === 0) {
      toggleNoResultError(true);
    }

    setFilterResult(newResult);
  }

  // Here we show the update form on click
  function displayUpdateSetting(_id, item) {
    setIdItemToBeUpdated(_id);
    setItemToBeUpdated(item);
    toggleShowUpdateForm(true);
    toggleDisplayContainer(true);
    toggleShowFullList(false);
  }

  // Here we show the insert form on click
  function addSetting() {
    toggleDisplayContainer(true);
    toggleShowFullList(false);
    toggleInsertForm(true);
    toggleShowUpdateForm(false);
  }

  return (
    <div>
      {showFullList && (
        <section className={styles["buttons-filter-container"]}>
          <section className={styles["buttons-section"]}>
            <div className={styles["button-wrapper"]}>
              <FunctionalButton type="button" handleClick={addSetting}>
                Add {title}
              </FunctionalButton>
            </div>
          </section>
          <input
            value={searchInput}
            className={styles["search-input-field"]}
            placeholder={`filter ${route}`}
            onChange={(e) => {
              setSearchInput(e.target.value.toLowerCase());
              filterResultsList(e.target.value.toLowerCase());
            }}
          />
        </section>
      )}
      {showFullList && (
        <p>Please click on the {title} to update or delete the data.</p>
      )}
      {loading && <p>Loading...</p>}
      {errorMessage && (
        <section className={styles["error-section"]}>
          <p>{databaseMessage}</p>
        </section>
      )}

      {showFullList && noResultError && (
        <section className={styles["error-section"]}>
          <p>No results. Please try again.</p>
        </section>
      )}
      {showFullList &&
        filterResult.map((item) => {
          const { _id } = item;
          return (
            <div className={styles["item-wrapper"]} key={_id}>
              <FormSettingsItem
                handleClick={() => displayUpdateSetting(_id, item[title])}
                item={item[title]}
                id={_id}
                title={title}
              />
            </div>
          );
        })}

      {displayContainer && (
        <div className={styles.container}>
          {showUpdateForm && !errorMessage && (
            <UpdateForm
              route={route}
              itemToBeUpdated={itemToBeUpdated}
              idItemToBeUpdated={idItemToBeUpdated}
              setItemToBeUpdated={setItemToBeUpdated}
              title={title}
              toggleShowFullList={toggleShowFullList}
              toggleDisplayContainer={toggleDisplayContainer}
              toggleReloadAll={toggleReloadAll}
            />
          )}

          {insertForm && !errorMessage && (
            <AddForm
              route={route}
              title={title}
              toggleShowFullList={toggleShowFullList}
              toggleDisplayContainer={toggleDisplayContainer}
              toggleReloadAll={toggleReloadAll}
              toggleInsertForm={toggleInsertForm}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Overview;
